import React from 'react';
import { Award, Users, MapPin, Clock, Shield, Star } from 'lucide-react';
import { COMPANY_CONFIG } from '../config/config';

const About = () => {
  const stats = [
    { number: '24+', label: 'Years of Experience', icon: Award },
    { number: '10', label: 'Bus Fleet', icon: Users },
    { number: '8', label: 'Routes Covered', icon: MapPin },
    { number: '24/7', label: 'Customer Support', icon: Clock }
  ];

  const values = [
    {
      icon: Shield,
      title: 'Safety First',
      description: 'We prioritize the safety of our passengers above everything else. All our buses undergo regular maintenance and safety checks.'
    },
    {
      icon: Clock,
      title: 'Punctuality',
      description: 'We understand the value of time. Our commitment to punctuality ensures you reach your destination on schedule.'
    },
    {
      icon: Star,
      title: 'Quality Service',
      description: 'We provide premium travel experience with comfortable seating, modern amenities, and professional staff.'
    },
    {
      icon: Users,
      title: 'Customer Focus',
      description: 'Our customers are at the heart of everything we do. We strive to exceed your expectations.'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section - Very Compact */}
      <section className="w-screen min-w-screen max-w-screen bg-gradient-to-r from-blue-600 to-blue-800 text-white py-2 lg:py-3">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto text-center">
            <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-1">About {COMPANY_CONFIG.appname}</h1>
            <p className="text-xs sm:text-sm text-blue-100">
          
          </p>
          </div>
        </div>
      </section>



      {/* Mission & Vision */}
      <section className="py-16 bg-gradient-to-r from-blue-50 to-indigo-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Mission */}
            <div className="bg-white rounded-xl shadow-lg p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
              <p className="text-gray-600 leading-relaxed">
                Our journey began with a simple goal: to make bus travel more comfortable, reliable, and accessible for everyone. We connect passengers with trusted transport partners through a seamless seat-booking experience, saving time and removing uncertainty. By combining modern technology with responsible service standards, we aim to improve travel safety, transparency, and comfort—one journey at a time.
              </p>
            </div>
            
            {/* Vision */}
            <div className="bg-white rounded-xl shadow-lg p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Vision</h3>
              <p className="text-gray-600 leading-relaxed">
                To become the leading premium bus booking platform, where comfort, trust, and excellence come first.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Experience the {COMPANY_CONFIG.appname} Difference
          </h2>
          <p className="text-xl mb-8 text-blue-100">
            Join thousands of satisfied customers who trust us for their travel needs
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/book"
              className="bg-white text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors shadow-lg"
            >
              Book Your Journey
            </a>
            <a
              href="/contact"
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors"
            >
              Get in Touch
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
